import { TableV2 } from '@anytag/shared-atoms';
import { InstagramReelPostItem } from '@anytag/graphql';
import { PostDetailsType, TableData } from '@anytag/shared-types';
import { InfluencerInstagramAnalyticsReelDetailsModal } from '@anytag/shared-molecules';
import { useAnalyticsInstagramReelPostsListTable } from './hooks';

export interface AnalyticsInstagramReelPostsListProps extends TableData<InstagramReelPostItem> {
  mainSocialAccountId?: number;
}

export const AnalyticsInstagramReelPostsList = ({
  loading,
  data = [],
  mainSocialAccountId
}: AnalyticsInstagramReelPostsListProps) => {
  const { columns } = useAnalyticsInstagramReelPostsListTable();

  return (
    <>
      <TableV2 loading={loading} columns={columns} data={data} rowHeight="62px" noTopBorderRadius hasBorder />
      <InfluencerInstagramAnalyticsReelDetailsModal
        posts={data.map(({ id }): PostDetailsType => ({ id: String(id), mainSocialAccountId }))}
        isAnalytics
      />
    </>
  );
};
